<template>
  <section id="test-vocacional">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-7 mx-auto d-flex justify-content-center align-items-center">
          <div class="content-wrapper text-center">
            <h3 class="text-size-titulo1 text-color-white">¿Has decidido ya tu futuro universitario?</h3>
            <hr class="mt-3 mb-4 hr--centered">
            <p class="text-color-white mt-3">Si tienes clara cuál es tu vocación, pincha en <strong>SÍ</strong>.</p>
            <p class="text-color-white mb-5">Si, por lo contrario, aún tienes dudas sobre qué carrera estudiar, pincha en <strong>NO</strong>.</p>
            <div class="row">
              <div class="col-6">
                <a class="btn btn-rounded btn-white mx-auto mt-3" @click="questionStore.step = 'crmform'; questionStore.knowStudy=true">Sí</a>
              </div>
              <div class="col-6">
                <a class="btn btn-rounded btn-white mx-auto mt-3" @click="questionStore.step = 'question'; questionStore.knowStudy=false">No</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  import {useQuestionStore} from "@/stores/question.js";

  const questionStore = useQuestionStore();
</script>
